import {
    Box,
    Stack,
    Typography,
    Paper,
    Chip,
} from "@mui/material";
import { useEffect, useState } from "react";

const cardSx = {
    bgcolor: "#212B36",
    borderRadius: "14px",
    border: "1px solid rgba(0, 184, 217, 0.15)",
    p: 2,
    transition: "all .2s ease",
    "&:hover": {
        borderColor: "rgba(0, 184, 217, 0.4)",
        transform: "translateY(-2px)",
    }
};

const innerBoxSx = {
    bgcolor: "#1C252E",
    p: 1.5,
    borderRadius: "10px",
    border: "1px solid #2F3A45",
};

const ProfileCard_ttx = ({ team, name, scenario }) => {
    const [scenario_card, setScenario_card] = useState(scenario)
    const secureThumbnail =
        scenario?.thumbnail_url?.startsWith("http://")
            ? scenario?.thumbnail_url.replace("http://", "https://")
            : scenario?.thumbnail_url;
    const difficultyColor = {
        Easy: "#36B37E",
        Medium: "#FFAB00",
        Hard: "#FF5630"
    };



    const setData = () => {
        setScenario_card(scenario)
        // console.log({ scenario_card }, 'difficulty, thumbnail_url, name, title ')
    }


    useEffect(() => {
        setData()
    }, [scenario])

    return (
        <Stack spacing={2}>

            {/* Thumbnail */}
            <Paper sx={{
                bgcolor: "#1C252E",
                p: 1.5,
                borderRadius: "10px",
                border: "1px solid #2F3A45",

            }}>
                <Box
                    sx={{
                        bgcolor: "#1C252E",
                        borderRadius: "10px",
                        // height: "40vh",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"

                    }}>
                    <Box
                        component="img"
                        src={secureThumbnail}
                        alt="Image"
                        sx={{
                            width: "100%",
                            height: "240px",
                            objectFit: "cover",
                            objectPosition: "center",
                            borderRadius: "10px"
                        }}
                    />

                </Box>

                <Typography
                    variant="h3"
                    sx={{
                        textAlign: "left",
                        mt: 1,
                        mb: 0.5,
                        fontWeight: 600
                    }}
                >
                    {name}
                </Typography>

                <Box
                    sx={{
                        mt: 2,
                        p: 1.5,
                        borderRadius: "10px",
                        bgcolor: "#111A21",
                        border: "1px solid rgba(0,184,217,0.15)"
                    }}
                >
                    <Stack spacing={1.2}>
                        <Stack direction="row" justifyContent="space-between">
                            <Typography variant="caption" sx={{ color: "#919EAB" }}>
                                Scenario :
                            </Typography>
                            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                {scenario?.name}
                            </Typography>
                        </Stack>

                        <Stack direction="row" justifyContent="space-between">
                            <Typography variant="caption" sx={{ color: "#919EAB" }}>
                                Category :
                            </Typography>
                            <Typography variant="subtitle2">
                                {scenario?.category_name}
                            </Typography>
                        </Stack>

                        <Stack direction="row" justifyContent="space-between">
                            <Typography variant="caption" sx={{ color: "#919EAB" }}>
                                Type :
                            </Typography>
                            <Typography variant="subtitle2">
                                {scenario?.type}
                            </Typography>
                        </Stack>

                        <Stack direction="row" justifyContent="space-between">
                            <Typography variant="caption" sx={{ color: "#919EAB" }}>
                                Difficulty :
                            </Typography>

                            <Chip
                                label={scenario?.severity}
                                size="small"
                                sx={{
                                    height: 22,
                                    fontWeight: 600,
                                    bgcolor: "rgba(255,171,0,0.15)",
                                    color: difficultyColor[scenario?.difficulty] || "#00B8D9"
                                }}
                            />
                        </Stack>
                    </Stack>
                </Box>


                {/* <Stack
                    direction="coloumn"
                    alignItems="center"
                    justifyContent="space-between"
                    height={"30%"}
                    border={'1px solid white'}
                >


                    <Typography
                        variant="h4"
                    >
                        {scenario?.name}
                    </Typography>



                    <Typography
                        variant="h4"
                    >
                        {scenario?.category_name}
                    </Typography>


                    <Typography
                        variant="h4"
                    >
                        {scenario?.points}
                    </Typography>

                    <Typography
                        variant="h4"
                    >
                        {scenario?.type}
                    </Typography>



                    <Typography
                        variant="h4"
                    >
                        {scenario?.difficulty}
                    </Typography>
                </Stack> */}
            </Paper>

            {/* Name */}
            <Paper sx={cardSx}>
                <Box sx={innerBoxSx}>
                    <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                    >
                        <Typography
                            variant="caption"
                            sx={{ color: "#919EAB", fontWeight: 500 }}
                        >
                            User
                        </Typography>

                        <Chip
                            label={name}
                            size="small"
                            sx={{
                                fontWeight: 600,
                                bgcolor: "rgba(0,184,217,0.15)",
                                color: "#00B8D9"
                            }}
                        />
                    </Stack>
                </Box>
            </Paper>

            {/* Team */}
            <Paper sx={cardSx}>
                <Box sx={innerBoxSx}>
                    <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                    >
                        <Typography
                            variant="caption"
                            sx={{ color: "#919EAB", fontWeight: 500 }}
                        >
                            Team
                        </Typography>

                        <Chip
                            label={team}
                            size="small"
                            sx={{
                                fontWeight: 600,
                                bgcolor: "rgba(0,184,217,0.15)",
                                color: "#00B8D9"
                            }}
                        />
                    </Stack>
                </Box>
            </Paper>



        </Stack >
    );
};

export default ProfileCard_ttx;